import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ReactComponent as ConfiguratorButton } from '../../assets/configuratorButton.svg';
import { useTranslation } from 'react-i18next';

interface ConfiguratorMenuDropdownProps {
  onToggleConfigurator: () => void;
  onUploadMenu: () => void;
}

const ConfiguratorMenuDropdown: React.FC<ConfiguratorMenuDropdownProps> = ({
  onToggleConfigurator,
  onUploadMenu,
}) => {
  const { t } = useTranslation(['catalogue']);

  return (
    <Menu as='div' className='relative inline-block text-left'>
      <Menu.Button className='sm:absolute sm:ml-8 mt-2 bg-white sm:h-12 sm:w-12 duration-300 rounded-full flex items-center justify-center hover:bg-gray-200 focus:outline-none'>
        <ConfiguratorButton />
      </Menu.Button>

      <Transition
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute z-30 right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
          <div className='px-1.5 py-1.5'>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onToggleConfigurator}
                  className={`${
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-900'
                  } group flex w-full items-center rounded-sm px-2 py-2 text-sm`}
                >
                  {t('configurator.label', 'Configurator')}
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onUploadMenu}
                  className={`${
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-900'
                  } group flex w-full items-center rounded-sm px-2 py-2 text-sm`}
                >
                  {t('upload_menu.button', 'Upload Menu')}
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default ConfiguratorMenuDropdown;
